import { Checkbox, TableCell, TableRow } from "@mui/material";
import React from "react";

const TableRowSection = ({
  isItemSelected,
  row,
  numberType,
  handleClickRow,
  labelId,
  handleNavigateToDetails,
}) => {
  // const [showTableActionDropDown, setShowTableActionDropDown] = useState(false);
  return (
    <TableRow
      hover
      // onClick={(event) => handleClickRow(event, row.id)}
      role="checkbox"
      aria-checked={isItemSelected}
      tabIndex={-1}
      key={row.id}
      selected={isItemSelected}
      sx={{
        cursor: "pointer",
        height: 48,
        background: numberType === true ? "#F2F2F2" : "#fff",
      }}
    >
      <TableCell
        padding="checkbox"
        style={{ background: "#fff" }}
        onClick={(event) => handleClickRow(event, row.id)}
      >
        <Checkbox
          color="primary"
          checked={isItemSelected}
          inputProps={{
            "aria-labelledby": labelId,
          }}
        />
      </TableCell>
      <TableCell
        // component="th"
        id={labelId}
        align="left"
        scope="row"
        padding="none"
        onClick={handleNavigateToDetails}
        style={tableTitleFieldStyles}
      >
        {row.dateReported}
      </TableCell>
      <TableCell
        padding="none"
        align="left"
        style={{ border: "1px solid #BABABA" }}
      >
        {row.reportedId}
      </TableCell>
      <TableCell
        padding="none"
        align="left"
        style={{ border: "1px solid #BABABA" }}
      >
        {row.reportedStatus}
      </TableCell>
      <TableCell
        padding="none"
        align="left"
        style={{ border: "1px solid #BABABA" }}
      >
        {row.reporterUsername}
      </TableCell>
      <TableCell padding="none" align="left" style={tableCellStyles}>
        {row.reporterType}
      </TableCell>
      <TableCell padding="none" align="left" style={tableCellStyles}>
        {row.reportedReason}
      </TableCell>
      <TableCell padding="none" align="left" style={tableCellStyles}>
        {row.qtTitle}
      </TableCell>
      <TableCell padding="none" align="left" style={tableCellStyles}>
        {row.qtId}
      </TableCell>
      <TableCell padding="none" align="left" style={tableCellStyles}>
        {row.reactionId}
      </TableCell>
      <TableCell
        align="left"
        padding="none"
        style={tableCellStyles}
        // onClick={() => setShowTableActionDropDown(!showTableActionDropDown)}
      >
        {row.actionTaken}
        {/*
        <Grid container>
          {row.qtStatus}
          <img
          src={icons.dropdownIcon}
          alt=""
          onClick={() => setShowTableActionDropDown(!showTableActionDropDown)}
          style={{ width: 24, height: 24, marginLeft: "auto" }}
          />
          {showTableActionDropDown && (
            // <Grid style={{background: "red"}}>
            <ActionDropdown table={true} />
            // </Grid>
            )}
            </Grid>
          */}
      </TableCell>
    </TableRow>
  );
};

export default TableRowSection;

const tableTitleFieldStyles = {
  border: "1px solid #BABABA",
  paddingLeft: 10,
  color: "#00A7CD",
  // fontWeight: 600,
  fontFamily: "Avenir Book, sans-serif",
};

const tableCellStyles = {
  paddingLeft: 10,
  border: "1px solid #BABABA",
  cursor: "default",
  fontFamily: "Avenir Book, sans-serif",
};
// const tableStatusCellStyles = {
//   border: "1px solid #BABABA",
//   cursor: "pointer",
//   fontWeight: 600,
//   fontFamily: "Avenir Book, sans-serif"
// };
